import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Col, Container, Image, Modal, Row } from 'react-bootstrap';
import WelcomePageSection from './welcome-page-section';
import PrivacyPolicySection from './privacy-policy-section';
import { GamePlayerContext } from '../../../context/game-context';

export default function WelcomePageUT({ handleSkip, handleContinue }) {

    const isPlayAsGuest = GamePlayerContext((state) => state.isPlayAsGuest);
    const [currentState, setCurrentState] = useState('welcome');
    // console.log(`/img/logo/${minimap.sceneName}/logo.png`);
    return (<>
        <Container>
            <Modal show={true} className="welcome-page-ut" centered>
                <Modal.Body className="no-padding">
                    <div className={"image-background"} style={{ backgroundImage: "url('/img/loading/ut/bg.jpg')" }}>
                        <div className='logo-section'>
                            <Image src="/img/logo/ut/logo.png" className={"logo"} />
                        </div>
                    </div>
                    <div className='text-section'>
                        {currentState == 'welcome' && <WelcomePageSection handleSkip={handleSkip} handleContinue={handleContinue}/>}
                        {currentState == 'privacy' && <PrivacyPolicySection />}
                        {currentState == 'welcome' && !isPlayAsGuest &&
                            <Row>
                                <Col className='text-center' style={{ marginTop: '10px' }}>
                                    <a href='#' onClick={e => setCurrentState('privacy')}>Privacy Policy</a>
                                </Col>
                            </Row>
                        }
                        {currentState == 'privacy' &&
                            <Row>
                                <Col className='text-center' style={{ marginTop: '10px' }}>
                                    <Button variant="default-dark" className="w-100" style={{ maxWidth: '180px' }}
                                        onClick={e => handleSkip()}
                                    >
                                        Lanjut
                                    </Button>
                                </Col>
                            </Row>
                        }
                    </div>

                </Modal.Body>
            </Modal>
        </Container>
    </>
    )
}
